import React from 'react';
import { Box, Flex, Progress, Text } from '@chakra-ui/react';

const StudentDashboardExamResult = ({subject, unit, score,colors }) => {
    
  return (
    <Box>
        <Flex alignItems={'center'} flexDirection={'column'} gap={1} w={'full'} mb={5}>
        <Flex width={'100%'} justifyContent={'space-between'} alignItems={'center'} mb={1} gap={3} >
            <Text color={'#000000'} fontWeight={'600'} fontSize={'10px'} lineHeight={'100%'}>Unit {unit} - <span style={{color: '#9696BB', fontWeight:"500"}}>{subject}</span></Text>
            <Progress width={'50%'} size={'sm'} value={score} borderRadius={'20px'} bgColor={'#E7E7E7'} 
            sx={{
                '& > div': {
                backgroundColor: colors,
                }
            }}/>
            <Text  color={'#000000'} fontWeight={'600'} fontSize={'10px'} lineHeight={'100%'}>{score}%</Text>
        </Flex>
        </Flex>
  </Box>
  )
}

export default StudentDashboardExamResult;